<template>
  <div v-if="tableData.length" class="work-schedules-table">
    <div class="work-schedules-table_title">
      {{ title }}
    </div>
    <vuescroll v-if="tableData.length" :ops="ops">
      <v-simple-table class="work-tables_table work-tables_table__couriers">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left" width="15%">
                Сотрудник
              </th>
              <!--              <th class="text-center" width="10%">
                Всего <br> смен
              </th>-->
              <th class="text-center" width="10%">
                Всего <br>часов
              </th>
              <th v-if="showOrdersCount" class="text-center" width="10%">
                Всего <br> заказов
              </th>
              <th
                v-for="(item, j) in datesRow"
                :key="j"
                class="text-center"
              >
                {{ item.date }} <br>
                <span class="day-week">{{ getDayOfTheWeek(item.date) }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, key) in tableData"
              :key="key"
              class="value-td"
            >
              <td class="text-no-wrap">
                {{ item.userName }}
              </td>
              <!--              <td class="text-center">
              </td>-->
              <td class="text-center">
                {{ item.totalWorkHours }}
              </td>
              <td v-if="showOrdersCount" class="text-center">
                {{ item.totalOrders || 0 }}
              </td>
              <td
                v-for="(workItem, i) in item.data"
                :key="workItem.date + i"
                class="text-center"
              >
                <span v-if="!workItem.workTime" class="no-work-label">вых</span>
                <span v-else class="work-label">{{ workItem.workTime }}</span>

                <span v-if="showOrdersCount && workItem.orders" class="orders-cont-label">
                  ({{ workItem.orders }})
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </vuescroll>
    <div v-else class="no-data-label">
      Нет записей за выбранный период
    </div>
  </div>
</template>

<script>
  import vuescroll from 'vuescroll'
  import moment from 'moment'

  export default {
    name: 'WorkSchedulesTable',
    components: { vuescroll },
    props: {
      title: String,
      tableData: {
        type: Array,
        default: () => [],
      },
      showOrdersCount: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        ops: {
          vuescroll: {
            mode: 'native',
            sizeStrategy: 'percent',
            detectResize: true,
          },
          scrollPanel: {
            scrollingX: true,
            scrollingY: false,
          },
          rail: {
            size: '8px',
            background: 'transparent',
            opacity: 1,
            keepShow: false,
          },
          bar: {
            showDelay: 500,
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#D4DDEB',
            opacity: 1,
            hoverStyle: false,
            specifyBorderRadius: false,
            minSize: 0,
            size: '6px',
            disable: false,
          },
        },
      }
    },
    computed: {
      datesRow () {
        return this.tableData.length ? this.tableData[0].data : []
      },
    },
    methods: {
      getDayOfTheWeek (date) {
        const m = moment().locale('ru-Ru')
        return m.localeData().weekdaysShort(moment(date, 'DD.MM.YYYY'))
      },
    },
  }
</script>

<style lang="less" scoped>
.work-schedules-table {
  margin-bottom: 50px;

  &_title {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .work-tables_table {
    ::v-deep {
      .v-data-table__wrapper {
        border-radius: 8px;
        box-shadow: 0 3px 4px rgba(192, 192, 192, 0.4);
        overflow: hidden;
        margin-bottom: 20px;
      }
    }

    thead {
      tr {
        background: #FF9D00;

        th {
          color: #252525 !important;
          font-weight: 500 !important;
          border-right: 1px solid #F09400;
          line-height: 1.2;
        }
      }
    }
    .no-work-label {
      color: #A7A7A7;
    }

    .work-label {
      font-weight: 500;
    }
    .orders-cont-label {
      color: #414141;
      font-weight: 400;
      font-size: 11px;
      padding-left: 5px;
    }

    .value-td {
      vertical-align: middle;
    }

    .day-week {
      color: #D67904;
      //font-size: 16px;
      font-weight: 400;
    }
  }
}

</style>
